import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ErrorView } from '../../error/ErrorView'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { IllustrationChoices } from '../../../components/common/Illustration'
import { ButtonVariant } from '../../../components/common/Button'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { theme } from '../../../theme/theme'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { i18nSocietyType } from '../../../i18n'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'

export const GetToKnowCompletedView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  useDocumentTitle(reverseDocumentTitle('management:get-to-know-completed'))
  return (
    <ErrorView
      className="text-center"
      title={translate('getToKnowCompletedScreen.title')}
      subtitle={translate('getToKnowCompletedScreen.description', {
        context: i18nSocietyType(society?.societyTypeDisplayName),
      })}
      illustration={IllustrationChoices.CHECKLIST}
      buttons={[
        {
          id: 'get-to-know-completed-view-continue-button',
          button: {
            label: translate('getToKnowCompletedScreen.button'),
            variant: ButtonVariant.PRIMARY,
            onClick: () => {
              navigate(reverseUrl('society', { id }))
            },
          },
        },
      ]}
      custom={
        <p style={{ ...theme.textVariants.base }} className="mt-8 container">
          {translate('getToKnowCompletedScreen.restartGuide')}
        </p>
      }
    />
  )
}
